document.addEventListener("DOMContentLoaded", async function () {
  const handleSizeChange = (event) => {
    const selectedVoltage = document.querySelector(
      '.swatch-element.variant-swatch[data-option="Voltage"] input:checked'
    )?.value;
    const selectedSize = document.querySelector(
      '.swatch-element.variant-swatch[data-option="Size"] input:checked'
    )?.value;

    if (
      selectedSize === "TAO Pillow Heated" &&
      selectedVoltage === "No Voltage"
    ) {
      document
        .querySelector(
          '.swatch-element.variant-swatch[data-option="Voltage"][data-value="110V"] input'
        )
        ?.click();
    } else if (
      selectedSize === "TAO Pillow No Heat" &&
      selectedVoltage !== "No Voltage"
    ) {
      document
        .querySelector(
          '.swatch-element.variant-swatch[data-option="Voltage"][data-value="No Voltage"] input'
        )
        ?.click();
    }
  };

  setTimeout(() => {
    handleSizeChange();
  }, 1000);

  window.addEventListener("variant:changed", handleSizeChange);
});
